const routes = [
  {
    name: 'main',
    path: '/',
    props: true,
    component: () => import('@/views/Main.vue'),
  },
  {
    name: 'searchPane',
    path: '/searchPane',
    component: () => import('@/views/SearchPane.vue')
  },
  {
    name: 'moreHistoryBasis',
    path: '/moreHistoryBasis',
    props: true,
    component: () => import('@/views/MoreHistoryBasis.vue')
  },
  {
    name: 'moreHistorySpread',
    path: '/moreHistorySpread',
    component: () => import('@/views/MoreHistorySpread.vue'),
    props: true
  },
]
export default routes;